import React from "react";

import UsageSummaryCard from "./UsageSummaryCard";
import UsageTable, { UsageTableRow } from "./UsageTable";
import styles from "../ProfilePage.module.scss";

export interface UsageSummaryItem {
  label: string;
  value: string;
}

interface UsageSectionProps {
  title: string;
  summary: UsageSummaryItem[];
  columns: string[];
  rows: UsageTableRow[];
  emptyText: string;
}

const UsageSection: React.FC<UsageSectionProps> = ({
  title,
  summary,
  columns,
  rows,
  emptyText,
}) => (
  <div className={styles.developerUsageSection}>
    <h5>{title}</h5>
    <div className={styles.developerUsageSummaryCards}>
      {summary.map((item) => (
        <UsageSummaryCard
          key={item.label}
          label={item.label}
          value={item.value}
        />
      ))}
    </div>
    {rows.length > 0 ? (
      <UsageTable columns={columns} rows={rows} />
    ) : (
      <p className={styles.developerEmptyText}>{emptyText}</p>
    )}
  </div>
);

export default UsageSection;
